<template>
  <div class="col">
    <div class="row">
      <h2>Import de pièces</h2>
    </div>
    <div class="row">
      <div class="col">
        <label for="startNumber">ID de départ</label>
      </div>
      <div class="col">
        <input
          id="startNumber"
          v-model="startNumber"
          class="field"
          type="number"
        >
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="total">Nombre d'itérations</label>
      </div>
      <div class="col">
        <input
          id="total"
          v-model="amount"
          class="field"
          type="number"
        >
      </div>
    </div>
    <div class="row">
      <div class="col">
        <custom-button
          class="green"
          @click.native="startProcess"
        >
          Démarrer
        </custom-button>
      </div>
    </div>
    <div class="row progress-row">
      <div class="col">
        <div class="progress-bar">
          <div
            class="progress"
            :style="'width:' + progress + '%'"
          ></div>
        </div>
      </div>
      <div class="col">
        <span class="percent">{{ progress.toFixed(2) }} %</span>
      </div>
    </div>
    <div
      v-if="finished"
      class="row"
    >
      <div class="col">
        <div class="row">
          Succès : {{ success }}
        </div>
        <div class="row">
          Erreurs : {{ errors }}
        </div>
        <div class="row">
          Dernier index fait : {{ finishedIndex }}
        </div>
        <div
          v-if="errors > 0"
          class="row"
        >
          IDs en erreur : {{ failedIds.join(', ') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomButton from './../micro-components/custom-button';
  import NumistaAPI from './../../tools/NumistaAPI';
  import FirebaseCoin from './../../tools/FirebaseCoin';

  export default {
    name: 'AdminImportCoins',
    components: { CustomButton },
    data() {
      return {
        progress: 0,
        finishedIndex: 0,
        success: 0,
        errors: 0,
        failedIds: [],
        finished: false,
      };
    },
    created() {
      this.startNumber = 1;
      this.amount = 10;
    },
    methods: {
      reset() {
        this.progress = 0;
        this.success = 0;
        this.errors = 0;
        this.failedIds = [];
        this.finished = true;
      },
      async startProcess() {
        this.reset();
        const actualIndex = parseInt(this.startNumber, 10);
        const lastIndex = parseInt(this.amount, 10);
        for (let i = actualIndex; i < actualIndex + lastIndex; i++) {
          try {
            const coin = await NumistaAPI.getDetails(i);
            const coinToSave = FirebaseCoin.parseCoin(coin);
            await FirebaseCoin.addCoin(coinToSave);
            this.success++;
            this.finishedIndex = i;
            this.progress = ((this.errors + this.success) * 100) / (lastIndex - 1);
          } catch (e) {
            this.errors++;
            this.finishedIndex = i;
            this.failedIds.push(i);
          }
        }
        this.finished = true;
      },
      async process() {

      }
    }
  };
</script>

<style scoped>
    h2 {
        margin-top: 0;
    }

    .progress-bar {
        width: 450px;
        height: 10px;
        border: 1px solid black;
        border-radius: 3px;
        overflow: hidden;
    }

    .progress {
        height: 10px;
        border-radius: 3px;
        background: darkgreen;
        width: 0;
    }

    .progress-row .col {
        justify-content: center;
    }

    .percent {
        margin-left: 5px;
    }
</style>
